import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';



import {
  ProtocolReducer,
  ProtocolDetailReducer,
  VersionReducer,
  StudyAgentsReducer,
  CirbReducer,
  IntegrationsReducer,
  OpenReducer,
  PSRsReducer,
  ParticipationReducer,
  FundingReducer
} from './protocols';
import {
  loadingReducer, errorReducer, modalReducer, commonReducer
} from './common';
import AdminReducer from './protocols/admin/adminReducer';

export const rootReducer = history => combineReducers({
  router: connectRouter(history),
  protocol: ProtocolReducer,
  prtDetails: ProtocolDetailReducer,
  versions: VersionReducer,
  studyAgents: StudyAgentsReducer,
  cirbData: CirbReducer,
  integrations: IntegrationsReducer,
  fundings: FundingReducer,
  openData: OpenReducer,
  psrs: PSRsReducer,
  participation: ParticipationReducer,
  modal: modalReducer,
  loading: loadingReducer,
  error: errorReducer,
  common: commonReducer,
  adminState: AdminReducer
});
